import ApplicationSerializer from "./application";

export default class LoadBalancerErrorSerializer extends ApplicationSerializer {
  usesProxy = true;

  normalize(modelClass, resourceHash, prop) {
    let parts = resourceHash.split(" ");

    let normalizedHash = {
      id: parts[0],
      text: resourceHash,
    };

    return super.normalize(modelClass, normalizedHash, prop);
  }
}
